<template>
  <main class="article-gallery">
    <div class="article-gallery__wrapper">
      <div class="article-gallery__carousel">
        <transition-group tag="div" class="slides-wrapper" :name="desktopTransitionName">
          <template v-for="(slide, index) in articleData.blocks">
            <div
              class="article-gallery__slide article-gallery__slide_text"
              v-if="slide.type == 'text'"
              :key="slide.id"
              v-show="index == curDesktopSlideIndex"
            >
              <div class="article-deskr">
                <div class="article-deskr__wrapper">
                  <div class="article-deskr__title-wrapper">
                    <span
                      v-for="(titlePart, index) in articleData.title"
                      :key="index"
                      :class="`article-deskr__title article-deskr__title_${index < 3 ? index+1 : 3 }`"
                    >
                      {{ titlePart }}
                    </span>
                  </div>
                  <pre class="article-deskr__deskr">{{ articleData.descr }}</pre>
                  <p class="article-deskr__deskr article-deskr__deskr_mobile">{{ articleData.descr }}</p>
                  <pre class="article-deskr__more">{{ articleData.more }}</pre>
                  <p class="article-deskr__more article-deskr__more_mobile">{{ articleData.more }}</p>
                </div>
              </div>
              <img
                v-show="articleData.textImage.url"
                class="article-gallery__image article-gallery__image_text"
                :src="articleData.textImage.url"
              >
            </div>
            <div
              class="article-gallery__slide article-gallery__slide_whole"
              v-else-if="slide.type == 'whole'"
              :key="slide.id"
              v-show="index == curDesktopSlideIndex"
            >
              <img class="article-gallery__image" :src="slide.images[0].url" >
            </div>
            <div
              class="article-gallery__slide article-gallery__slide_half"
              v-else
              :key="slide.id"
              v-show="index == curDesktopSlideIndex"
            >
              <img
                v-show="slide.images[0].url"
                class="article-gallery__image article-gallery__image_left"
                :src="slide.images[0].url" />
              <img 
                v-show="slide.images[1].url"
                class="article-gallery__image article-gallery__image_right"
                :src="slide.images[1].url" />
            </div>
          </template>
          <div key="controls" class="carousel-controls">
            <div @click="slideLeft"></div>
            <div @click="slideRight"></div>
          </div>
        </transition-group>
      </div>
    </div>
  </main>
</template>

<script>
import fitty from 'fitty'
import { apiGetArticle } from '../utils/api'

export default {
  name: "ArticleGallery",
  data() {
    return {
      articleData: {
        preview: { url: '', filePath: '', file: '' },
        textImage: { url: '', filePath: '', file: '' },
        previewText: '',
        title: '',
        descr: '',
        more: '',
        blocks: []
      },
      curDesktopSlideIndex: 0,
      desktopTransitionName: "fade-left",
      resizeHandler: null
    };
  },
  async mounted() {
    const articleIndex = this.$store.state.clientArticles.findIndex((el) => el.id == this.$route.params.id)
    if (articleIndex != -1) {
      this.articleData = this.$store.state.clientArticles[articleIndex]
      if (!Array.isArray(this.articleData.title)) {
        this.articleData.title = this.articleData.title.match(/\S+/g)
      }
      // add extra block for slide with text
      if (this.articleData.blocks.length > 0 && this.articleData.blocks[0].type != 'text') {
        this.articleData.blocks.unshift({ id: Math.random() * 100, type: 'text' })
      }
    } else {
      try {
        this.articleData = await apiGetArticle(this.$route.params.id)
        this.articleData.title = this.articleData.title.match(/\S+/g)
        this.articleData.blocks.unshift({ id: Math.random() * 100, type: 'text' })
      } catch(e) {
        console.error(e.message)
      }
    }
    this.$nextTick(() => {
      fitty('.article-deskr__title', { minSize: 50, maxSize: 144 })
    })
  },
  methods: {
    slideLeft() {
      this.desktopTransitionName = "fade-right";
      this.curDesktopSlideIndex == 0
        ? (this.curDesktopSlideIndex = this.articleData.blocks.length - 1)
        : (this.curDesktopSlideIndex = this.curDesktopSlideIndex - 1);
    },
    slideRight() {
      this.desktopTransitionName = "fade-left";
      this.curDesktopSlideIndex == this.articleData.blocks.length - 1
        ? (this.curDesktopSlideIndex = 0)
        : (this.curDesktopSlideIndex = this.curDesktopSlideIndex + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
.article-gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 35px 100px 0;
  overflow-x: hidden;
  &__wrapper {
    flex-grow: 1;
    display: grid;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
  &__carousel {
    display: grid;
    position: relative;
    height: 73vh;
    max-width: 100%;
    overflow-x: visible;
  }
  &__slide {
    display: flex;
    justify-content: center;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    width: 100%;
    max-width: 100%;
    height: 73vh;
    overflow-x: visible;
    &_half > img:first-child {
      margin-right: 10px;
    }
    &_half > img {
      max-width: 50%;
    }
    &_whole > img {
      max-width: 100%;
    }
  }
  &__image {
    height: 100%;
    object-fit: cover;
    justify-self: center;
    &_text, &_right {
      justify-self: left;
    }
    &_left {
      justify-self: right;
    }
  }
  &__info {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__name {
    @include fonts.ap-reg;
    font-size: 20px;
    margin-right: 12px;
  }
}

.slides-wrapper {
  position: relative;
  display: grid;
  height: 73vh;
}

.article-deskr {
  overflow-x: visible;
  z-index: 1;
  justify-self: right;
  &__wrapper {
    width: 475px;
  }
  &__title-wrapper {
    width: 130%;
    line-height: 0.8;
    margin: 100px 0 35px;
  }
  &__title {
    @include fonts.ap-reg;
    display: inline-block;
    text-transform: uppercase;
    &_1 {
      transform: translateX(-20px);
    }
    &_2 {
      transform: translateX(-60px);
    }
    &_3 {
      transform: translateX(0);
    }
  }
  &__deskr {
    @include fonts.ap-reg;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 30px;
    &_mobile {
      display: none;
    }
  }
  &__more {
    @include fonts.mo-reg;
    font-size: 13px;
    line-height: 18px;
    &_mobile {
      display: none;
    }
  }
}

.carousel-controls {
  display: grid;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  height: 100%;
  grid-template-columns: 1fr 1fr;
  z-index: 2;
  cursor: pointer;
}

// for text resize
.fit {
  display: inline-block;
  white-space: nowrap;
}

@media screen and (max-height: 800px) and (orientation: landscape) {
  .article-deskr {
    &__title-wrapper {
      margin: 50px 0 25px;
    }
    &__deskr {
      margin-bottom: 25px;
    }
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .article-gallery {
    padding: 55px 100px 55px;
    &__wrapper {
      display: block;
      height: auto;
    }
    &__carousel {
      height: auto;
      overflow: visible;
    }
    &__slide {
      overflow: visible;
      display: flex !important;
      height: auto;
      flex-direction: column;
      grid-column: auto;
      grid-row: auto;
      & > img:not(:last-child) {
        margin-bottom: 30px;
      }
      &_half > img {
        max-width: 100%;
      }
    }
    &__image {
      position: relative;
      width: 100%;
      height: auto;
    }
  }
  .slides-wrapper {
    row-gap: 30px;
    height: auto;
  }
  .carousel-controls {
    display: none;
  }
  .article-deskr {
    justify-self: left;
    &__title-wrapper {
      width: 100%;
      margin-top: 0;
    }
    &__title {
      transform: translateX(-10px);
    }
    &__deskr {
      margin: 0 0 25px 0;
      font-size: 18px;
    }
    &__more {
      margin: 0 0 25px 0;
    }
  }
}

@media screen and (max-width: 767px) {
  .article-gallery {
    padding: 30px 12px 55px;
    &__wrapper {
      display: block;
      height: auto;
    }
    &__carousel {
      overflow: visible;
      height: auto;
    }
    &__slide {
      display: flex !important;
      height: auto;
      flex-direction: column;
      grid-column: auto;
      grid-row: auto;
      overflow: visible;
      & > img:not(:last-child) {
        margin-bottom: 30px;
      }
      &_half > img {
        max-width: 100%;
      }
    }
    &__image {
      position: relative;
      width: 100%;
      height: auto;
    }
  }
  .slides-wrapper {
    row-gap: 30px;
    height: auto;
  }
  .carousel-controls {
    display: none;
  }
  .article-deskr {
    width: 100%;
    &__wrapper {
      width: 100%;
    }
    &__title-wrapper {
      width: 100%;
      height: auto !important;
      margin: 0 0 20px
    }
    &__title {
      transform: translateX(-10px);
    }
    &__deskr {
      display: none;
      &_mobile {
        display: block;
        margin: 0 0 15px 0;
        font-size: 18px;
      }
    }
    &__more {
      display: none;
      &_mobile {
        display: block;
        margin: 0 0 15px 0;
      }
    }
  }
}

// slides animation
.fade-left-enter {
  opacity: 0;
  transform: translateX(400px);
}

.fade-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.fade-left-enter-active {
  transition: all 400ms ease;
}

.fade-left-leave {
  opacity: 1;
  transform: translateX(0);
}

.fade-left-leave-to {
  opacity: 0;
  transform: translateX(-400px);
}

.fade-left-leave-active {
  transition: all 400ms ease;
}

.fade-right-enter {
  opacity: 0;
  transform: translateX(-400px);
}

.fade-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.fade-right-enter-active {
  transition: all 400ms ease;
}

.fade-right-leave {
  opacity: 1;
  transform: translateX(0);
}

.fade-right-leave-to {
  opacity: 0;
  transform: translateX(+400px);
}

.fade-right-leave-active {
  transition: all 400ms ease;
}
</style>